import React from "react";
import Body from "./Body";

const OtherCharity = () => {
  const educationalColumn = [
    {
      header: "Donation id",
      accessor: "donationId",
      render: (_, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div>
            <span style={{ color: "var(--tableColor)" }}>#</span>
            <strong>{row.donationId}</strong>
          </div>
        </div>
      ),
    },
    {
      header: "Time & date",
      accessor: "dateTime",
      render: (value) => (
        <span style={{ color: "black", fontSize: "0.8rem" }}>{value}</span>
      ),
    },
    {
      header: "Eqvt. amount (INR)",
      accessor: "amount",
      render: (value) => <span className="green-text">₹ {value}</span>,
    },
  ];

  const educationalDonation = [
    {
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
    {
      donationId: "2398476282",
      dateTime: "10:30 PM, 02 Oct, 2025",
      amount: 2300,
    },
  ];
  const _this = { educationalColumn, educationalDonation };
  return <Body {..._this} />;
};

export default OtherCharity;
